import { render, staticRenderFns } from "./KilometerRegistrations.vue?vue&type=template&id=a06a635c&scoped=true"
import script from "./KilometerRegistrations.vue?vue&type=script&lang=js"
export * from "./KilometerRegistrations.vue?vue&type=script&lang=js"
import style0 from "./KilometerRegistrations.vue?vue&type=style&index=0&id=a06a635c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06a635c",
  null
  
)

export default component.exports